import { Link, Button } from "@chakra-ui/react";
import styles from "./styles.module.scss";

const DocumentosPortal = () => {
  return (
    <div className={styles.publicacoes}>
      <h1>Publicações Oficiais</h1>
      <div className={styles.box}>
        <h3 id="docs">
          Relatório de Administração e Demonstrações Contábeis 2020:{" "}
        </h3>
        <Link
          isExternal
          colorScheme="blue"
          href="http://interbrasilsaude.com.br.s3-website-us-east-1.amazonaws.com/static/media/relatorio-administracao-2020.2cb4c6ec.pdf"
        >
          <Button colorScheme="blue">Abrir</Button>
        </Link>
      </div>

      <div className={styles.boxDocs}>
        <h1>Documentação da Companhia</h1>
        <div className={styles.box}>
          <h3>1 - 1ª e 2ª ATA + CNPJ: </h3>
          <Link
            isExternal
            colorScheme="blue"
            href="http://interbrasilsaude.com.br.s3-website-us-east-1.amazonaws.com/static/media/Atos_constitutivos.pdf"
          >
            <Button colorScheme="blue">Abrir</Button>
          </Link>
        </div>
        <div className={styles.box}>
          <h3>2 - Registro na ANS: </h3>
          <Link
            isExternal
            colorScheme="blue"
            href="http://interbrasilsaude.com.br.s3-website-us-east-1.amazonaws.com/static/media/2-Registro-na-ANS.4fb958e8.pdf"
          >
            <Button colorScheme="blue">Abrir</Button>
          </Link>
        </div>
        <div className={styles.box}>
          <h3>3 - Certidão Negativa de Débitos dos Tributos Municipais: </h3>
          <Link
            isExternal
            colorScheme="blue"
            href="http://interbrasilsaude.com.br.s3-website-us-east-1.amazonaws.com/static/media/3.%20INTERBRASIL%20-%20CND%20ISS%20SAO%20PAULO%20(1).pdf"
          >
            <Button colorScheme="blue">Abrir</Button>
          </Link>
        </div>
        <div className={styles.box}>
          <h3>3 - Certidão Negativa de Tributos Federais: </h3>
          <Link
            isExternal
            colorScheme="blue"
            href="http://interbrasilsaude.com.br.s3-website-us-east-1.amazonaws.com/static/media/3-CERTIDAO-NEGATIVA-DE-TRIBUTOS-FEDERAIS.0a00b4ad.pdf"
          >
            <Button colorScheme="blue">Abrir</Button>
          </Link>
        </div>
        <div className={styles.box}>
          <h3>3 - Certidão Negativa de Débitos trabalhistas: </h3>
          <Link
            isExternal
            colorScheme="blue"
            href="http://interbrasilsaude.com.br.s3-website-us-east-1.amazonaws.com/static/media/3-CERTIDAO-NEGATVA-DE-DEBITOS-TRABALHISTAS.98c27bf1.pdf"
          >
            <Button colorScheme="blue">Abrir</Button>
          </Link>
        </div>
        <div className={styles.box}>
          <h3>3 - Certificado de Regularidade do FGTS: </h3>
          <Link
            isExternal
            colorScheme="blue"
            href="http://interbrasilsaude.com.br.s3-website-us-east-1.amazonaws.com/static/media/3.%20INTERBRASIL%20-%20CND%20FGTS%20(1).pdf"
          >
            <Button colorScheme="blue">Abrir</Button>
          </Link>
        </div>
        <div className={styles.box}>
          <h3>4 - Certidão InterBrasil CRM 2020: </h3>
          <Link
            isExternal
            colorScheme="blue"
            href="http://interbrasilsaude.com.br.s3-website-us-east-1.amazonaws.com/static/media/4-Certidao-Interbrasil-CRM-2020.565d4309.pdf"
          >
            <Button colorScheme="blue">Abrir</Button>
          </Link>
        </div>
        <div className={styles.box}>
          <h3>5 - CRO-CE: </h3>
          <Link
            isExternal
            colorScheme="blue"
            href="http://interbrasilsaude.com.br.s3-website-us-east-1.amazonaws.com/static/media/5-CRO-CE.bd476f7e.pdf"
          >
            <Button colorScheme="blue">Abrir</Button>
          </Link>
        </div>
        <div className={styles.box}>
          <h3>6 - Declaração de Ativos Garantidores: </h3>
          <Link
            isExternal
            colorScheme="blue"
            href="http://interbrasilsaude.com.br.s3-website-us-east-1.amazonaws.com/static/media/AtivosGarantidores%20(2).pdf"
          >
            <Button colorScheme="blue">Abrir</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DocumentosPortal;
